import { Component, OnInit, inject } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import {ModalRef} from '../../modal/modal-ref';
import {ModalConfig} from '../../modal/modal-config';


@Component({
    selector: 'app-title-form',
    templateUrl: './title-form.component.html',
    styleUrls: ['./title-form.component.scss'],
    imports: [FormsModule]
})
export class TitleFormComponent implements OnInit {
  private modal = inject(ModalRef);
  config = inject(ModalConfig);


  public inputData;
  public formData = { title: '', content: '', bg: '', showTitle: true};
  private id;
 constructor() {
   this.inputData = this.config.data;
 }

  ngOnInit() {
   if (this.inputData.content) {
     this.formData = this.inputData.content.attributes;
     this.id = this.inputData.id;
   }
  }

  onSaveTitle(formData: NgForm) {
   const formHTMLAttributes = formData.form.value;
   const data = {type: 'title', attributes: {
     page: this.inputData.page, ...formHTMLAttributes},
     id: this.id
     };

   this.modal.close(data);
  }
}
